import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Admin } from '../../../../apps/types/admin';
import { ENVIRONMENT_TOKEN } from '../../../../apps/values/environment.token';
import { MongoDBHttpService } from './mongodb-http/mongodb-http.service';

@Injectable({
  providedIn: 'root',
})
export class AdminServiceNew {
  private _mongoHttpService = inject(MongoDBHttpService);
  private _environmentToken = inject(ENVIRONMENT_TOKEN);

  constructor() {}

  getAdminProfile(userId: string): Observable<Admin | null> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<Admin>(this._environmentToken.profilesCollection)
      .findOne({
        $or: [{ auth_zero_user_id: userId }, { owner_user_id: userId }],
      });
  }
}
